<template>
  <div class="resource-home">
    <Card :dis-hover="true">
      <p style="text-align: center">
        <span style="font-size: 16px;font-weight: bolder">应急资源统计：</span>
        <Select style="width:200px">
          <Option v-for="item in []" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
        <Select style="width:200px;margin-left: 10px">
          <Option v-for="item in []" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </p>
    </Card>
    <Card :dis-hover="true" style="margin-top: 10px;">
      <p slot="title">应急物资</p>
      <Row :gutter="2" type="flex" justify="center">
        <Col :span="6" :offset="2" style="">
          <data-tag :colorClass="`bg-1`" style="border: 1px solid #abdcff;margin-top: 30px;">
            <template v-slot:tagContent>
              <span style="margin-top: 4px">应急物资总数</span>
              <span style="margin-top: 4px">10</span>
            </template>
          </data-tag>
          <data-tag :colorClass="`bg-2`" style="margin-top: 16px;border: 1px solid #8ce6b0;">
            <template v-slot:tagContent >
              <span style="">
                <Select style="width:100px">
                  <Option value="1">一个月</Option>
                </Select>
                物资总数
              </span>
              <span style="margin-top: 4px">10</span>
            </template>
          </data-tag>
          <data-tag :colorClass="`bg-3`" style="margin-top: 16px;border: 1px solid #ffd77a;">
            <template v-slot:tagContent>
              <span style="margin-top: 4px">已超期物资总数</span>
              <span style="margin-top: 4px">10</span>
            </template>
          </data-tag>
        </Col>
        <Col :span="14" style="height: 260px">
          <pie-chart :data-list="[]"></pie-chart>
        </Col>
      </Row>
    </Card>
    <Card :dis-hover="true" style="margin-top: 10px">
      <p slot="title">应急队伍</p>
      <Row :gutter="12">
        <Col :span="6">
          <data-tag :colorClass="`bg-1`" style="border: 1px solid #abdcff;">
            <template v-slot:tagContent>
              <span style="margin-top: 4px">应急队伍总数</span>
              <span style="margin-top: 4px">10</span>
            </template>
          </data-tag>
        </Col>
        <Col :span="6">
          <data-tag :colorClass="`bg-2`" style="border: 1px solid #8ce6b0;">
            <template v-slot:tagContent>
              <span style="margin-top: 4px">政府应急队伍</span>
              <span style="margin-top: 4px">10</span>
            </template>
          </data-tag>
        </Col>
        <Col :span="6">
          <data-tag :colorClass="`bg-3`" style="border: 1px solid #ffd77a;">
            <template v-slot:tagContent>
              <span style="margin-top: 4px">企业应急队伍</span>
              <span style="margin-top: 4px">10</span>
            </template>
          </data-tag>
        </Col>
        <Col :span="6">
          <data-tag :colorClass="`bg-4`" style="border: 1px solid #ffb08f;">
            <template v-slot:tagContent>
              <span style="margin-top: 4px">社会应急队伍</span>
              <span style="margin-top: 4px">10</span>
            </template>
          </data-tag>
        </Col>
      </Row>
    </Card>
    <Card :dis-hover="true" style="margin-top: 10px">
      <p slot="title">其他</p>
      <Row :gutter="12">
        <Col :span="6">
          <data-tag :colorClass="`bg-1`" style="border: 1px solid #abdcff;">
            <template v-slot:tagContent>
              <span style="margin-top: 4px">应急专家</span>
              <span style="margin-top: 4px">10</span>
            </template>
          </data-tag>
        </Col>
        <Col :span="6">
          <data-tag :colorClass="`bg-2`" style="border: 1px solid #8ce6b0;">
            <template v-slot:tagContent>
              <span style="margin-top: 4px">避难场所</span>
              <span style="margin-top: 4px">10</span>
            </template>
          </data-tag>
        </Col>
      </Row>
    </Card>
  </div>
</template>

<script>
import PieChart from '@/views/Resources/home/component/pieChart.vue'
import DataTag from '@/views/Resources/home/component/dataTag.vue'

export default {
  name: "home.vue",
  components: {DataTag, PieChart}
}
</script>

<style scoped lang="less">
.resource-home{
  .data-tag{
    display: flex;
    flex-direction: row;
    height: 50px;
    width: 100%;
    .tag-color{
      width: 10px;
      background-color: #abdcff;
    }
    .tag-content{
      width: calc(100% - 10px);
      border: 1px solid #abdcff;
      border-left: none;
      display: flex;
      justify-content: space-between;
      padding: 14px;
    }
  }
}

</style>
